"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VerifierStorage = /** @class */ (function () {
    function VerifierStorage(args) {
        this.CODE_VERIFIER_NAME = 'code_verifier';
        this.CODE_CHALLENGE_METHOD = 'SHA256';
        this.CODE_CHALLENGE_METHOD = args.method || this.CODE_CHALLENGE_METHOD;
    }
    VerifierStorage.prototype.setCodeVerifier = function (verifier) {
        sessionStorage.setItem(this.CODE_VERIFIER_NAME, verifier);
    };
    VerifierStorage.prototype.getCodeVerifier = function () {
        return sessionStorage.getItem(this.CODE_VERIFIER_NAME);
    };
    VerifierStorage.prototype.clearCodeVerifier = function () {
        sessionStorage.removeItem(this.CODE_VERIFIER_NAME);
    };
    VerifierStorage.prototype.getCodeChallengeMethod = function () {
        return this.CODE_CHALLENGE_METHOD;
    };
    VerifierStorage.prototype.isSha256 = function () {
        return !!~this.CODE_CHALLENGE_METHOD.toLowerCase().indexOf('sha256');
    };
    return VerifierStorage;
}());
exports.VerifierStorage = VerifierStorage;
//# sourceMappingURL=verifier.js.map


// WEBPACK FOOTER //
// ./~/@mtfe/sso-web/lib/store/verifier.js